import React, {useEffect} from "react";
import {useSelector} from "../../../shared-services/redux-tiny";
import {cartTools} from "../../cart/useCart";
import BasicFarmyModal from "./BasicFarmyModal";
import useModalQueue from "./useModalQueue";
import {t} from "../../../shared-services/translate";
import UnavailableItemsList from "../../cart/Unavailable.ItemsList";
import UnavailableCTA from "../../cart/Unavailable.CTA";

const UnavailableProductsModal = () => {
  const modalName = "UnavailableProductsModal";

  const {pushToQueue, closeModal} = useModalQueue(modalName);
  const {hasUnavailableItems} = cartTools();

  const {currentCart} = useSelector(state => state.cart);
  const {pageCode} = useSelector(state => state.router);

  const onRemove = () => {
    closeModal();
    window.location.reload();
  };

  useEffect(() => {
    if (pageCode === "checkout" && hasUnavailableItems()) {
      pushToQueue();
    } else closeModal();

    return () => closeModal();
  }, [pageCode, currentCart]);

  return <BasicFarmyModal modalName={modalName} closeOnClickOutside={false} hideCloseButton={true}>
    <div className="margin-bottom-20 font-weight-900">
      {t("products.unavailable")}:
    </div>
    <UnavailableItemsList order={currentCart}/>
    <UnavailableCTA order={currentCart} onRemove={onRemove}/>
  </BasicFarmyModal>;
};

export default UnavailableProductsModal;
